import { BrandVariants, createLightTheme, Theme } from "@fluentui/react-components";

const syntheiaBrandTheme: BrandVariants = {
  10: "#030204",
  20: "#1B141E",
  30: "#2D2033",
  40: "#3C2945",
  50: "#4C3358",
  60: "#5C3D6B",
  70: "#6C487E",
  80: "#785688",
  90: "#846593",
  100: "#91749E",
  110: "#9D83A9",
  120: "#AA93B4",
  130: "#B6A3BF",
  140: "#C3B3CA",
  150: "#D0C3D6",
  160: "#DDD3E1",
};

const syntheiaBrandWebLight: Theme = {
  ...createLightTheme(syntheiaBrandTheme),
  colorBrandBackground: "#6A467C",
};

syntheiaBrandWebLight.colorBrandForeground1 = syntheiaBrandTheme[30];

export const SyntheiaBrandWebLight = syntheiaBrandWebLight;
